import React from "react";
import {Dropdown, DropdownChangeEvent} from "primereact/dropdown";
import { T } from "services/lang/LanguageService";
import useAccessibleCompanies from "hooks/useAccessibleCompanies";
import {useUserState} from "store/user-store";
import useCurrentCompanyContext from "hooks/useCurrentCompanyContext";

export default function CompanyContextSelectFragment() {
    const companies = useAccessibleCompanies()
    const currentContext = useCurrentCompanyContext()

    const setCurrentContext = useUserState((state) => state.setCompanyContext)

    if(!companies) return false

    if(companies.length <= 1) {
        return false
    }

    const selectItems =  companies?.map((company) => {
        return {
            label: company.title,
            value: company.companyReference
        }
    })

    const onChangeHandler = (e: DropdownChangeEvent) => {
        const company = companies?.find((c) => c.companyReference === e.value)
        setCurrentContext(company)
    }

    return <Dropdown placeholder={T("action.select-company-context")}
                  value={currentContext?.companyReference}
                  options={selectItems}
                  filter
                  filterMatchMode="contains"
                  onChange={onChangeHandler}
        />
}